import { render, staticRenderFns } from "./EditItemWindow.vue?vue&type=template&id=80005852&scoped=true"
import script from "./EditItemWindow.vue?vue&type=script&lang=js"
export * from "./EditItemWindow.vue?vue&type=script&lang=js"
import style0 from "./EditItemWindow.vue?vue&type=style&index=0&id=80005852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80005852",
  null
  
)

export default component.exports